
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ScrollingImageEffect extends BaseParallaxEffect implements ParallaxEffect {
    private imageCache: Map<string, HTMLImageElement> = new Map();

    public render(pc: ParallaxContext): void {
        const { ctx, config, width, height, time } = pc;
        const url = config.parallaxImageUrl;
        if (!url) return;

        let img = this.imageCache.get(url);
        if (!img) {
            img = new Image();
            img.src = url;
            img.referrerPolicy = "no-referrer";
            this.imageCache.set(url, img);
        }

        if (img.complete) {
            ctx.save();
            ctx.globalAlpha *= (config.parallaxMediaOpacity || 1.0);
            
            const scale = config.parallaxScale || 1.0;
            const iw = img.width * scale;
            const ih = img.height * scale;
            
            const autoX = (config.parallaxAutoScrollX || 0) * time * 100;
            const autoY = (config.parallaxAutoScrollY || 0) * time * 100;
            
            const startX = -width - (autoX % iw);
            const startY = -height - (autoY % ih);

            for (let x = startX; x < width + buffer; x += iw) {
                for (let y = startY; y < height + buffer; y += ih) {
                    ctx.drawImage(img, x, y, iw, ih);
                }
            }
            ctx.restore();
        }
    }
}

const buffer = 1000;
